import MainNotification from '@/Manager/Notification/main.manager';
import Global from '@/scripts/Global';
import { serverBus } from '@/main';
import VueSignals from '@/scripts/VueSignals';

export default {
    name: 'RequestNotificationPopUp',
    data() {
        return {
            needsPermission: true
        }
    },
    watch: {
        needsPermission(value) {
            if (!value) {
                this.closeWindow();
            }
        }
    },
    methods: {
        closeWindow() {
            window.close();
        },
        enableNotification() {
            MainNotification.init();
        },
    },
    mounted() {
        Global.Splash(0);
        serverBus.$on(VueSignals.NOTIFICATION_NEED_PERMISSION, (data) => {
            this.needsPermission = data
        });
    }

}
